"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _container = require("@dbi-tools/ui-kit/lib/components/container");

var _row = require("@dbi-tools/ui-kit/lib/components/row");

var _col = require("@dbi-tools/ui-kit/lib/components/col");

var _useStyles = require("../../hooks/useStyles");

var _themeOptions = require("../../helpers/theme-options");

var _helpers = require("../../helpers");

var _const = require("../../const");

var _lazyLoadImage = require("../lazy-load-image");

var _headerTitles = require("../header-titles");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _responsiveImage = _interopRequireDefault(require("../image/responsive-image"));

var _style = _interopRequireDefault(require("./style"));

var _const2 = require("./const");

var _promo = require("./promo.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promo = function Promo(props) {
  var id = props.id,
      headline1 = props.headline1,
      headline2 = props.headline2,
      description = props.description,
      buttons = props.buttons,
      _props$align = props.align,
      align = _props$align === void 0 ? _const.Align.CENTER : _props$align,
      _props$size = props.size,
      size = _props$size === void 0 ? _const2.PromoHeight.LARGE : _props$size,
      _props$copySize = props.copySize,
      copySize = _props$copySize === void 0 ? _const2.PromoCopySize.LARGE : _props$copySize,
      backgroundColor = props.backgroundColor,
      _props$theme = props.theme,
      currentTheme = _props$theme === void 0 ? _themeOptions.ThemeVariants.MOCASSIN : _props$theme,
      iconFileReference = props.iconFileReference,
      iconAltText = props.iconAltText,
      bgImages = props.bgImages;
  var isImageTheme = currentTheme === 'image-light' || currentTheme === 'image-dark';
  var _promoThemeStrategy$c = _const2.promoThemeStrategy[currentTheme],
      headline1Color = _promoThemeStrategy$c.headline1Color,
      headline2Color = _promoThemeStrategy$c.headline2Color,
      type = _promoThemeStrategy$c.type;
  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isLargeBlock = size === _const2.PromoHeight.LARGE;
  var isCopyLarge = copySize === _const2.PromoCopySize.LARGE;
  var isBackgroundOn = backgroundColor !== 'transparent';
  var padding = isLargeBlock ? 30 : 15;
  var containerIndent = [padding, 0, padding];
  var basicStyles = isCopyLarge ? (0, _useStyles.useStyles)('a', _style.default) : (0, _useStyles.useStyles)('b', _style.default);
  var theme = {
    $theme: currentTheme,
    $styles: basicStyles
  };

  if (!headline1 && !headline2 && !description) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      align: "center",
      as: "h2",
      fontWeight: "bold",
      measure: "h1"
    }, "Please configure PROMO component");
  } // TODO merge quote + promo


  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_promo.StyledBox, {
    p: containerIndent,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_PROMO,
    id: id
  }, isImageTheme && /*#__PURE__*/_react.default.createElement(_responsiveImage.default, {
    bgImages: bgImages,
    fit: "cover"
  }), /*#__PURE__*/_react.default.createElement(_container.Container, null, /*#__PURE__*/_react.default.createElement(_row.Row, {
    justifyContent: _const2.justifyContentStrategy[align]
  }, /*#__PURE__*/_react.default.createElement(_col.Col, {
    lg: 8,
    md: 9,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_promo.PromoStyled, {
    alignItems: _const2.alignItemsStrategy[align],
    height: _const2.promoHeightStrategy[size] - padding * 2,
    isBackgroundOn: isBackgroundOn,
    bg: backgroundColor,
    colorContrast: _const.colorBlackOrWhite[backgroundColor],
    isLargeBlock: isLargeBlock
  }, iconFileReference && /*#__PURE__*/_react.default.createElement(_promo.PromoLogoStyled, {
    mb: 5,
    display: "flex"
  }, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
    src: iconFileReference,
    placeholderSrc: iconFileReference,
    alt: iconAltText,
    height: 50
  })), /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: headline1Color,
    headline2Color: headline2Color,
    align: align,
    noGutters: true
  }), buttons && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    buttons: buttons,
    color: isBackgroundOn ? _const.ButtonContrast[backgroundColor] : (0, _helpers.getButtonColorByTheme)(isDarkTheme)
  })))))));
};

var _default = Promo;
exports.default = _default;